import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import swal from 'sweetalert2';
import { MdOutlineEmail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';

import './contact.css';

const Contact = () => {
  const mail = 'danialsyed66@gmail.com';
  const messenger = 'danial.syed.58';
  const whatsapp = '+92 337 040 7835';

  const form = useRef();

  const sendEmail = e => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_c90qonl',
        'template_3ukjths',
        form.current,
        'h5MVEFqps2sUz2K9X'
      )
      .then(
        result => {
          console.log(result.text);
          swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Email sent.',
            showConfirmButton: true,
            timer: 2000,
          });
        },
        error => {
          console.log(error.text);
          swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'There was an error sending email.',
            showConfirmButton: true,
            timer: 2000,
          });
        }
      );

    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>{mail}</h5>
            <a href={`mailto:${mail}`} target="_blank" rel="noreferrer">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <RiMessengerLine className="contact__option-icon" />
            <h4>Messenger</h4>
            <h5>{messenger}</h5>
            <a
              href={`https://m.me/${messenger}`}
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>whatsApp</h4>
            <h5>{whatsapp}</h5>
            <a
              href={`https://api.whatsapp.com/send?phone=${whatsapp
                .slice(1)
                .split(' ')
                .join('')}`}
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
          />

          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
